/**
 * Path the app is served under, from vite.config.base:
 * "/" for local, dev/uat/prod, or "/pull/1234" for a PR build.
 */
export const BASE_PATH = import.meta.env.BASE_URL

export const ROUTES_CONFIG = {
  // fx
  tile: "/fx-spot/:symbol",
  tiles: "/fx-tiles",
  blotter: "/fx-blotter",
  analytics: "/fx-analytics",
  // credit
  credit: "/credit",
  creditRfqs: "/credit-rfqs",
  newRfq: "/credit-new-rfq",
  creditBlotter: "/credit-blotter",
  sellSide: "/credit-sellside",
  styleguide: "/styleguide",
  admin: "/admin",
  // equities
  equities: "/equities/*",
  equitiesDesktop: "desktop/*",
  equitiesMobile: "mobile/*",
  equitiesDesktopLogin: "desktop/login",
  equitiesMobileLogin: "mobile/login",
  index: "/desktop",
  trade: "/trade",
  tradeInstrument,
  orderHistory: "equities/desktop/orderhistory",
  positions: "equities/desktop/positions",
  // admin/CI
  status: "/status",
  // limit checker
  limitChecker: "/limit-checker",
} as const

function tradeInstrument(symbol: string) {
  return `trade/instrument/${symbol}`
}
tradeInstrument.routePattern = `${ROUTES_CONFIG.trade}/instrument/:symbol`

export const CREDIT_RFQ_EXPIRY_SECONDS = 120
export const CREDIT_SELL_SIDE_TICKET_HEIGHT = 262

export const HIGHLIGHT_ROW_FLASH_TIME = 3000

export const ADAPTIVE_URL = "https://weareadaptive.com"
export const AERON_URL = "https://aeron.io"
export const ADAPTIVE_EMAIL = "sales@weareadaptive.com"

export type SocialPlatform = "Twitter" | "LinkedIn" | "Github"
export const SOCIAL_ADDRESSES: Record<SocialPlatform, string> = {
  Twitter: "https://twitter.com/WeAreAdaptive",
  LinkedIn: "https://www.linkedin.com/company/adaptive-consulting-ltd/",
  Github: "https://github.com/adaptiveConsulting/",
}
